import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ServiceMessageBrokerFactory,
  ServiceMessageBroker,
} from "shared/provider-webworker";

import { BlotterFilterLookupService } from "./BlotterFilterLookupService";
import { PrimaryLookupService } from "../../impl/PrimaryLookupService";
import { IBlotterFilterPromiseLookupService } from "../IBlotterFilterPromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";

import { CubiqWorker } from "../../../worker/CubiqWorker";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class BlotterFilterPrimaryLookupService
  extends PrimaryLookupService<string, CubiqTS.BlotterFilterImpl>
  implements IBlotterFilterPromiseLookupService
{
  constructor(
    protected base: BlotterFilterLookupService,
    protected factory: ServiceMessageBrokerFactory,
    protected cubiqWorker: CubiqWorker,
  ) {
    super(base, factory, CubiqTS.BlotterFilterImpl, cubiqWorker, "BlotterFilterImpl");

    cubiqWorker.isAuth(`${this.constructor.name}`).then(
      () => {
        let lookupRequest: CubiqTS.BlotterFilterListRequestImpl =
          new CubiqTS.BlotterFilterListRequestImpl();

        this.cubiqWorker
          .postServiceRequest(lookupRequest)
          .then((report: CubiqTS.StandardReportImpl) => {
            this.base.prime(report.results);
            this._primed.resolve(true);
          })
          .catch((error: Error) => {
            console.debug("BlotterFilter prime failed");
            this._primed.reject(error);
          });
      },
      (reason) => {
        console.debug("BlotterFilterPrimaryLookupService: Failed to prime: " + reason);

        this._primed.resolve(false);
      },
    );

    this.broker.registerMethod(
      "getMyBlotterFilters",
      [],
      this.getMyBlotterFilters.bind(this),
      this.VALUE,
    );
    this.broker.registerMethod(
      "getMySystemBlotterFilters",
      [],
      this.getMySystemBlotterFilters.bind(this),
      this.VALUE,
    );
    this.broker.registerMethod(
      "deleteItemsByIds",
      [PRIMITIVE],
      this.deleteItemsByIds.bind(this),
      PRIMITIVE,
    );
    this.broker.registerMethod(
      "createFilterItem",
      [this.VALUE],
      this.createFilterItem.bind(this),
      this.VALUE,
    );
    this.broker.registerMethod(
      "updateFilterItem",
      [this.VALUE],
      this.updateFilterItem.bind(this),
      this.VALUE,
    );
  }

  getMyBlotterFilters(): Promise<Array<CubiqTS.BlotterFilterImpl>> {
    return new Promise<Array<CubiqTS.BlotterFilterImpl>>((res, rej) => {
      res(this.base.getMyBlotterFilters(this.cubiqWorker.getUserId()));
    });
  }

  getMySystemBlotterFilters(): Promise<Array<CubiqTS.BlotterFilterImpl>> {
    return new Promise<Array<CubiqTS.BlotterFilterImpl>>((res, rej) => {
      res(this.base.getMyBlotterSystemFilters());
    });
  }

  getBase(): BlotterFilterLookupService {
    return this.base;
  }

  createFilterItem(item: CubiqTS.BlotterFilterImpl): Promise<boolean> {
    return this.updateFilterItem(item);
  }

  updateFilterItem(item: CubiqTS.BlotterFilterImpl): Promise<boolean> {
    let blotterRequest: CubiqTS.BlotterFilterRequestImpl = new CubiqTS.BlotterFilterRequestImpl();
    blotterRequest.filterId = item.filterId;
    blotterRequest.filterName = item.filterName;
    blotterRequest.blotterType = item.blotterType;
    blotterRequest.queryGroup = item.queryGroup;
    blotterRequest.extendedInfo = item.extendedInfo;
    return this.cubiqWorker.postServiceRequest(blotterRequest);
  }

  deleteItemsByIds(ids: number[]): Promise<boolean> {
    let filterIds: Array<CubiqTS.Long> = new Array<CubiqTS.Long>();
    ids.forEach((id) => filterIds.push(new CubiqTS.Long(id)));
    let blotterRequest: CubiqTS.BlotterFilterDeleteRequestImpl =
      new CubiqTS.BlotterFilterDeleteRequestImpl();
    blotterRequest.filterIds = filterIds;
    return this.cubiqWorker.postServiceRequest(blotterRequest);
  }
}
